import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import dynamic from "next/dynamic";
import Header from "@components/shared/header";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

const Footer = dynamic(() => import("@components/shared/footer"));

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <>
            <Header />
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#01b9c3" />
                </div>
                <FormSection iconsFillColor="#01b9c3" />
            </div>
            <Footer />
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
